export function DevCeremonyBanner() {
  return (
    <div className="dev-ceremony-banner" role="alert">
      <div className="dev-ceremony-banner__inner">
        <strong>Pre-launch pools.</strong> These mainnet pools were generated from a single dev
        contribution to the trusted setup, not the production multi-party ceremony. The prover key
        is known to the developer — funds in these pools are <em>not</em> private against the
        developer and could in principle be withdrawn with a forged proof. Treat them as on-mainnet
        rehearsal, not the production protocol. The ceremony will be re-run before the official
        launch.
      </div>
    </div>
  );
}
